import React, { useId } from 'react';

export interface ComboboxOption {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: ComboboxOption[];
  placeholder?: string;
  name?: string;
  style?: React.CSSProperties;
}

const DEFAULT_STYLE: React.CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  background: 'var(--nx-surface-3)',
  border: '1px solid var(--nx-border)',
  borderRadius: 8,
  fontSize: 13,
  color: 'var(--nx-text-primary)',
  outline: 'none',
  boxSizing: 'border-box',
};

/**
 * A freely-typable input that also offers a native pick-from-list dropdown,
 * via <input list> + <datalist>. No external dependency.
 */
const EditableCombobox: React.FC<Props> = ({ value, onChange, options, placeholder, name, style }) => {
  const listId = useId();

  return (
    <>
      <input
        list={listId}
        name={name}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ ...DEFAULT_STYLE, ...style }}
      />
      <datalist id={listId}>
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </datalist>
    </>
  );
};

export default EditableCombobox;
